import { gql } from '@src/lib/gql'

export const RESPOND_TO_ADVISOR_AGREEMENT = gql`
  mutation RespondToAdvisorAgreement($input: RespondToAdvisorAgreementInput!) {
    respondToAdvisorAgreement(input: $input) {
      advisorAgreement {
        id
        advisorAgreementId
        statusKey
        advisorNotes
        declinedAt
        status {
          id
          key
          title
        }
      }
    }
  }
`
